export const experiences = [
  {
    id: "infor",
    company: "Infor India Pvt Ltd",
    role: "Software Engineer",
    location: "Hyderabad, Telangana",
    startDate: "Oct 2023",
    endDate: "Current",
    isCurrent: true,
    achievements: [
      "Built bulk workflow execution feature enabling 1000+ datasets from single config, reducing manual effort by 10x",
      "Built automated workflows using React Flow, reducing task completion time by 75%",
      "Applied optimization techniques (code splitting, lazy loading, memoization) — 40% load time improvement",
      "Resolved 3,000+ SonarQube issues, authored 2,000+ Jest test cases, 90% test coverage",
      "Leveraged AI tools (ChatGPT, Claude.ai, Kiro, Amazon Q) for code generation, debugging, and reviews — 10x productivity boost",
      "Built real-time job status tracking using WebSockets",
      "Integrated HelpDesk on data mesh platform enabling bug reports with screenshots and screen recordings",
      "Provided US-shift client support, collaborated with backend, QA, and product teams in agile sprints"
    ],
    skills: ["React.js", "TypeScript", "React Flow", "Jest", "Redux", "Webpack", "Docker", "WebSocket", "Micro Frontends", "D3.js"]
  },
  {
    id: "masai",
    company: "Masai School",
    role: "Full Stack Web Developer",
    location: "Bengaluru, Karnataka",
    startDate: "Aug 2022",
    endDate: "Jul 2023",
    isCurrent: false,
    achievements: [
      "Built production-grade full-stack applications using MERN stack, Redux, JWT, Chakra UI, and Chart.js",
      "Practiced agile development, Git-based workflows, and third-party library integrations in solo and team environments",
      "Solved 400+ DSA problems and invested 2,000+ hours in hands-on coding and system design practice"
    ],
    skills: ["React.js", "TypeScript", "Redux", "Node.js", "Express.js", "MongoDB", "JWT", "Chart.js"]
  },
  {
    id: "digi-amigo",
    company: "Digi Amigo",
    role: "Technical Solution Executive",
    location: "Rajasamand, Rajasthan",
    startDate: "Dec 2020",
    endDate: "Jul 2021",
    isCurrent: false,
    achievements: [
      "Developed and maintained mobile-responsive web pages using HTML, CSS, and JavaScript, improving UI consistency across devices",
      "Implemented design adjustments to enhance user experience and accessibility",
      "Supported digital outreach by running Facebook, Instagram, and Google campaigns to drive traffic"
    ],
    skills: ["HTML", "CSS/SCSS", "JavaScript"]
  }
];
